const phrases = [
    "Quality over quantity",
    "No more ghosting",
    "5 matches a week",
    "Real conversations",
    "Privacy first",
    "Compatibility over chance",
    "Built for slow love",
    "Verified humans only",
];

export default function Marquee() {
    return (
        <div
            className="relative py-4 bg-[var(--ink)] text-[var(--paper)] border-y-2 border-[var(--ink)] overflow-hidden"
            data-testid="marquee"
        >
            <div className="flex whitespace-nowrap marquee-track">
                {[...phrases, ...phrases, ...phrases].map((p, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-6 px-8 font-display text-3xl lg:text-4xl"
                    >
                        {p}
                        <span className="text-[var(--hot)]">❦</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
